<template>
    <section class="categories">
        <div v-if="loading" class="cat-holder"></div>
        <div v-else class="container wrapper">
            <router-link :to="`/produtos/${categorie.url || categorie.id}`"
                         class="item" v-for="categorie in categories" :key="categorie.id">
                <lazy-image width="160px"
                            v-if="categorie.file !== null" :image="categorie.file"/>
<!--                <img :src="categorie.file.permalink" alt="">-->
                <h3 class="item__title">{{categorie.name}}</h3>
            </router-link>
        </div>

        <img class="mobile-mouse" src="@/assets/icons/black-mouse.svg" alt="">

        <div class="carousel-categories">
            <router-link v-for="categorie in categories" :to="`/produtos/${categorie.url || categorie.id}`" :key="categorie.id" class="item">
                <img v-if="categorie.file !== null" class="item__img" :src="categorie.file.permalink"/>
                <h3 class="item__title">{{categorie.name}}</h3>
            </router-link>
        </div>
    </section>
</template>

<script>
    import LazyImage from "../../Shared/LazyImage";

    export default {
        name: "HomeCategories",
        data() {
            return {
                categories: [],
                loading: true,
            }
        },
        components: {
            LazyImage
        },
        methods: {
            fetchCategories() {
                axios.get('/categories')
                    .then(r => {
                        this.categories = r.data;
                        this.loading = false;
                    })
            }
        },
        mounted() {
            this.fetchCategories();
        }
    }
</script>

<style lang="scss" scoped>
    .mobile-mouse {
        display: none;
    }

    .cat-holder {
        min-height: 256px;
        width: 100%;
        background: #fff;
    }

    .categories {
        margin-top: 60px;
    }

    .wrapper {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
    }

    .carousel-categories {
        display: none;
    }

    .item {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: center;
        width: 200px;
        margin-bottom: 20px;
        padding-bottom: 20px;
        transition: all .2s;
        border: 1px solid transparent;

        &:hover {
            border: 1px solid #e5e5e5;
        }

        &__img {
            margin-bottom: 10px;
        }

        &__title {
            font-family: 'HelveticaNeue', Arial, sans-serif;
            text-align: center;
            font-size: 1.125rem;
            color: #2b2b2b;
            font-weight: 500;
            margin-top: 10px;
        }
    }

    @media only screen and (max-width: 768px) {
        .wrapper {
            justify-content: center;
        }
    }

    @media only screen and (max-width: 767px) {
        .categories {
            padding: 15px 0px 15px 15px;
            margin: 60px auto 0 auto;
        }

        .wrapper {
            padding: 0 5px;
            width: 300px;
            justify-content: normal;
            flex-wrap: nowrap;
            overflow: scroll;
            display: none;
        }

        .carousel-categories {
            display: flex;
            align-items: flex-end;
            width: 100%;
            overflow: auto;
            padding-bottom: 20px;
        }

        .item {
            flex-shrink: 0;
            display: block;
            width: 65%;
            padding: 0 20px;
            margin: 0 auto;

            &:hover {
                border: none;
            }

            &__img {
                margin: 0 auto;
            }
        }

        .mobile-mouse {
            display: block;
            margin: -60px auto -10px auto;
            z-index: 10;
            position: relative;
        }
    }
</style>